import { useEffect, useState } from 'react';
import { API_POST, DBRequest, useConfig } from '../../api/api';
import { Box } from '@mui/material';
import { SalesObjectMatch } from './sales-object-matching/match-preview/SalesObjectMatch';
import { LeadMatch } from './sales-object-matching/match-preview/LeadMatch';
import { MatchContainer } from './sales-object-matching/MatchContainer';
import NoDataAnimation from '../animation/NoDataAnimation';
import Pagination from '../special/Pagination';

export const ExoSalesObjectMatching = ({ source, sourceId, status = 0 }) => {
  const config = useConfig();

  const sourceApiMap = {
    companyLead: `leads/companies/${sourceId}/matches?status[eq]=${status}`,
    personLead: `leads/persons/${sourceId}/matches?status[eq]=${status}`,
    salesObject: `sales-objects/${sourceId}/matches?status[eq]=${status}`,
  };

  const sourcePreviewMap = {
    companyLead: SalesObjectMatch,
    personLead: SalesObjectMatch,
    salesObject: LeadMatch,
  };

  const [matches, setMatches] = useState(null);

  useEffect(() => {
    if (sourceApiMap[source])
      DBRequest({ config, path: sourceApiMap[source], onResponse: setMatches });
  }, [config, status, sourceId, source]);

  const ElementComponent = sourcePreviewMap[source];

  function handleAdd(match) {
    removeMatchFromMatches(match);

    DBRequest({
      config,
      path: sourceApiMap[source],
      method: API_POST({
        status: 1,
        matchId: match.id,
      }),
      onError: () => setMatches(matches),
    });
  }

  function handleRemove(match) {
    removeMatchFromMatches(match);

    DBRequest({
      config,
      path: sourceApiMap[source],
      method: API_POST({
        status: 2,
        matchId: match.id,
      }),
      onError: () => setMatches(matches),
    });
  }

  function removeMatchFromMatches(match) {
    const newMatches = matches.data.filter((obj) => obj.id !== match.id);
    setMatches({ ...matches, data: newMatches });
  }

  return (
    <Box className="w-full flex flex-col h-full gap-2 justify-between overflow-hidden">
      <Box className="w-full flex flex-col gap-2 overflow-y-auto pr-2">
        {matches?.data.length === 0 && (
          <Box className="w-full h-full flex justify-center items-center">
            <NoDataAnimation />
          </Box>
        )}
        {matches?.data?.map((match, index) => (
          <MatchContainer
            key={`${match.id} ${index}`}
            match={match}
            onAdd={handleAdd}
            onRemove={handleRemove}
          >
            <ElementComponent match={match} />
          </MatchContainer>
        ))}
      </Box>
      <Pagination data={matches} setData={setMatches} setLoading={() => {}} />
    </Box>
  );
};
